module.exports = __webpack_public_path__ + "img/icon_wy17.b2eb0b95.png";